export const facebookLoginAppId = window.REACT_APP_FACEBOOK_APP_ID || '607402994957828';
export const facebookLoginConfigId = window.REACT_APP_FACEBOOK_CONFIG_ID || '432462516605271';
export const facebookBusinessLoginAppId = window.REACT_APP_FACEBOOK_BUSINESS_APP_ID || '1931504787374356';
export const facebookBusinessLoginConfigId = window.REACT_APP_FACEBOOK_BUSINESS_CONFIG_ID || '901083322220657';

